import React, { useEffect } from "react";
import { StyledCreateHolidayContainer, ModalDropDownStyles } from "./styles";
import Input from "../UI/Input";
import Button from "../UI/Button";
import { translate } from "../../utils/translations/translate";
import { useFormik } from "formik";
import { TaskValidationSchema } from "./schema";
import { Dropdown } from "../UI/Dropdown";
const STATUS_OPTIONS = [{
  label: "Active",
  value: "active",
  refVal: true
}, {
  label: "Inactive",
  value: "inactive",
  refVal: false
}]
const getStatusValue = (val) => {
  return STATUS_OPTIONS.find(option => option.value === val).refVal;
}
export const CreateEditProjectTask = ({ isCreateMode, savedData, onSave }) => {
  const formik = useFormik({
    initialValues: {
      isActive: true,
      taskName: "",
      taskId: "",
    },
    validationSchema: TaskValidationSchema,
    onSubmit: (values) => {
      onSave(values);
    },
  });
  const { setValues } = formik;
  const { taskName, isActive } = formik.values;
  const formTitle = isCreateMode
    ? translate("labels.createProjectTask")
    : translate("labels.editTask");
  const buttonText = isCreateMode
    ? translate("labels.createProjectTask")
    : translate("labels.saveChanges");
  useEffect(() => {
    if (savedData && typeof savedData === "object" && savedData.taskId) {
      setValues(savedData);
    }
  }, [savedData, setValues]);
  return (
    <StyledCreateHolidayContainer>
      <h1 className="tma_form_title">{formTitle}</h1>
      <form className="tma_prj_task_create_form" onSubmit={formik.handleSubmit}>
        <div className="tma_input_control">
          <Input
            labelText={translate("labels.name")}
            id="taskName"
            name="taskName"
            placeholder={translate("labels.taskName")}
            value={taskName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={{ maxLength: 100 }}
            error={formik.touched.taskName && Boolean(formik.errors.taskName)}
            helperText={formik.touched.taskName && formik.errors.taskName}
          />
        </div>
        <div className="tma_input_control">
          <Dropdown
            label={translate("labels.status")}
            options={STATUS_OPTIONS}
            id={"tma-task_status"}
            className="tma_task_status_drpdwn"
            initialValue={isActive ? "active" : "inactive"}
            key={isActive ? "active" : "inactive"}
            onChange={({ value }) => {
              formik.setFieldValue("isActive", getStatusValue(value));
            }}
          />
        </div>
        <div className="tma_form_actions">
          <Button
            className={"tma_create_holiday_submit"}
            type="submit"
            text={buttonText}
          />
        </div>
      </form>
      <ModalDropDownStyles />
    </StyledCreateHolidayContainer>
  );
};
